import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, Heading, List, ListItem, Text } from '@chakra-ui/react';
import { FT_PI_SIGNUP_IN_HEADER, FT_PI_AUTH0_LOGIN, FT_PIB_LOGIN_REDIRECT, GET_STATIC_CONTENT, SITE_LEISURE } from '@whitbread-eos/api';
import { Popover, Button } from '@whitbread-eos/atoms';
import { ManageBookingContainer } from '@whitbread-eos/molecules';
import { decodeIdToken, getAuthCookie, getLoggedInUserInfo, useAuthToken, useAuth0User, useRestQueryRequest, useUserData, useCustomLocale, useFeatureToggle, analytics, useAuth0Navigation, useQueryRequest } from '@whitbread-eos/utils';
import getConfig from 'next/config';
import { useSearchParams } from 'next/navigation';
import { useEffect, useLayoutEffect, useState, createElement as _createElement } from 'react';
import { AuthContentManagerPIVariant } from '../../../../index';
import { getPibLoginRedirectUrl, isBusinessPage, useLogoutWithRedirect } from '../../helpers/helpers';
import NavItem from '../NavItem';
import AuthSubNav from './AuthSubNav';
import { boxStyles, businessListStyles, headingStyles, linkStyles, listItemStyles, listStyles } from './NavigationMenu.style';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function NavigationMenu(_ref) {
  var _data$contactDetail, _data$contactDetail2;
  var labels = _ref.labels;
  var _ref2 = getConfig() || {},
    _ref2$publicRuntimeCo = _ref2.publicRuntimeConfig,
    publicRuntimeConfig = _ref2$publicRuntimeCo === void 0 ? {} : _ref2$publicRuntimeCo;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isManageBookingModalOpen = _useState2[0],
    setIsManageBookingModalOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoginModalOpen = _useState4[0],
    setIsLoginModalOpen = _useState4[1];
  var _useUserData = useUserData(),
    isLoggedIn = _useUserData.isLoggedIn;
  var _useAuthToken = useAuthToken(),
    token = _useAuthToken.token,
    isAuth0TokenEnabled = _useAuthToken.isAuth0Enabled;
  var _useAuth0User = useAuth0User(isAuth0TokenEnabled),
    auth0User = _useAuth0User.user;
  var _useFeatureToggle = useFeatureToggle(),
    isSignupInHeaderEnabled = _useFeatureToggle[FT_PI_SIGNUP_IN_HEADER],
    isAuth0Enabled = _useFeatureToggle[FT_PI_AUTH0_LOGIN],
    isPibLoginRedirectEnabled = _useFeatureToggle[FT_PIB_LOGIN_REDIRECT];
  var searchParams = useSearchParams();
  var manageBooking = (searchParams === null || searchParams === void 0 ? void 0 : searchParams.get('manage-booking')) === 'true';
  useLayoutEffect(() => {
    if (manageBooking) {
      setIsManageBookingModalOpen(true);
    }
  }, [manageBooking]);
  var email = isAuth0TokenEnabled && auth0User !== null && auth0User !== void 0 && auth0User.email ? auth0User.email : decodeIdToken(getAuthCookie()).email;
  var _useRestQueryRequest = useRestQueryRequest(['userDetails', token], 'GET', "".concat(publicRuntimeConfig.NEXT_PUBLIC_REST_API, "/customers/hotels/").concat(email, "?business=false"), {
      Authorization: "Bearer ".concat(token)
    }, {
      enabled: isLoggedIn && !!email
    }),
    data = _useRestQueryRequest.data;
  var _useCustomLocale = useCustomLocale(),
    language = _useCustomLocale.language,
    country = _useCustomLocale.country;
  var _useAuth0Navigation = useAuth0Navigation(),
    navigateToLogin = _useAuth0Navigation.navigateToLogin,
    navigateToLogout = _useAuth0Navigation.navigateToLogout,
    navigateToSignup = _useAuth0Navigation.navigateToSignup;
  var _useQueryRequest = useQueryRequest(['GetStaticContent', language, country], GET_STATIC_CONTENT, {
      country,
      language,
      site: SITE_LEISURE,
      businessBooker: false
    }),
    headerInformationData = _useQueryRequest.data;
  var logout = useLogoutWithRedirect(country, language, !!isAuth0Enabled, navigateToLogout);
  var _getLoggedInUserInfo = getLoggedInUserInfo(token),
    isBusiness = _getLoggedInUserInfo.isBusiness;
  useEffect(() => {
    var _headerInformationDat;
    var businessDomain = headerInformationData === null || headerInformationData === void 0 || (_headerInformationDat = headerInformationData.headerInformation) === null || _headerInformationDat === void 0 || (_headerInformationDat = _headerInformationDat.content) === null || _headerInformationDat === void 0 || (_headerInformationDat = _headerInformationDat.authentication) === null || _headerInformationDat === void 0 || (_headerInformationDat = _headerInformationDat.login) === null || _headerInformationDat === void 0 || (_headerInformationDat = _headerInformationDat.business) === null || _headerInformationDat === void 0 ? void 0 : _headerInformationDat.businessDomain;
    if (isLoggedIn && isBusiness && businessDomain) {
      window.location.href = getPibLoginRedirectUrl(businessDomain, language, country);
    }
  }, [isLoggedIn, isBusiness, headerInformationData, language, country]);
  var toggleManageModal = () => {
    setIsManageBookingModalOpen(!isManageBookingModalOpen);
  };
  var handleLoginClick = () => {
    var _headerInformationDat2;
    if (isPibLoginRedirectEnabled && isBusinessPage(window.location.pathname) && headerInformationData !== null && headerInformationData !== void 0 && (_headerInformationDat2 = headerInformationData.headerInformation) !== null && _headerInformationDat2 !== void 0 && (_headerInformationDat2 = _headerInformationDat2.content) !== null && _headerInformationDat2 !== void 0 && (_headerInformationDat2 = _headerInformationDat2.authentication) !== null && _headerInformationDat2 !== void 0 && (_headerInformationDat2 = _headerInformationDat2.login) !== null && _headerInformationDat2 !== void 0 && (_headerInformationDat2 = _headerInformationDat2.business) !== null && _headerInformationDat2 !== void 0 && _headerInformationDat2.businessDomain) {
      window.location.href = getPibLoginRedirectUrl(headerInformationData.headerInformation.content.authentication.login.business.businessDomain, language, country);
    } else if (isAuth0Enabled) {
      analytics.track('auth_sign_in_click', {
        authStep: 'sign_in_click'
      });
      navigateToLogin();
    } else {
      if (isLoginModalOpen) {
        analytics.remove(['loginClicked']);
      } else {
        analytics.update({
          loginClicked: true
        });
      }
      setIsLoginModalOpen(!isLoginModalOpen);
    }
  };
  var toggleLoginModal = () => {
    setIsLoginModalOpen(!isLoginModalOpen);
  };
  var LoginNavigation = () => {
    if (isSignupInHeaderEnabled && labels !== null && labels !== void 0 && labels.signUpButton) {
      return _jsxs(Flex, {
        gap: "0.5rem",
        children: [_jsx(Button, _objectSpread(_objectSpread({
          variant: "primary",
          onClick: handleLoginClick
        }, buttonStyles), {}, {
          children: labels.logIn
        })), _jsx(Button, _objectSpread(_objectSpread({
          variant: "primary",
          onClick: () => {
            if (isAuth0Enabled) {
              analytics.track('auth_sign_up_click', {
                authStep: 'sign_up_click'
              });
              navigateToSignup();
            } else {
              window.location.href = "/".concat(country, "/").concat(language, "/account/register.html?intcmp=navbar_register_button");
            }
          }
        }, buttonStyles), {}, {
          "data-testid": "Global-SignUp-Desktop",
          children: labels.signUpButton
        }))]
      });
    } else {
      return _jsx(NavItem, {
        "data-testid": "Global-Login-Desktop",
        onClick: handleLoginClick,
        title: labels.logIn
      });
    }
  };
  return _jsxs(Flex, {
    justifyContent: "flex-end",
    "data-testid": "menuWrapperId",
    alignItems: "center",
    children: [_jsx(Box, _objectSpread(_objectSpread({}, boxStyles), {}, {
      "data-testid": "listId",
      children: _jsx(Popover, {
        triggerItem: _jsx(NavItem, {
          title: labels.discoverPI
        }),
        children: labels.subNav && _jsx(Flex, {
          children: renderSubNavItems(labels.subNav, true)
        })
      })
    })), _jsx(Box, _objectSpread(_objectSpread({}, boxStyles), {}, {
      "data-testid": "listId",
      children: _jsx(Popover, {
        triggerItem: _jsx(NavItem, {
          title: labels.business
        }),
        children: _jsx(Flex, _objectSpread(_objectSpread({}, businessListStyles), {}, {
          children: (labels === null || labels === void 0 ? void 0 : labels.businessSubNav) && renderSubNavItems([labels.businessSubNav], false)
        }))
      })
    })), _jsxs(Box, _objectSpread(_objectSpread({}, boxStyles), {}, {
      "data-testid": "listId",
      children: [_jsx(NavItem, {
        onClick: toggleManageModal,
        title: labels.findBooking,
        "data-testid": "ManageBookingButton"
      }), _jsx(ManageBookingContainer, {
        onClose: toggleManageModal,
        isOpen: isManageBookingModalOpen
      })]
    })), _jsxs(Box, _objectSpread(_objectSpread({}, boxStyles), {}, {
      mr: "0",
      "data-testid": "listId",
      children: [!isLoggedIn ? _jsx(LoginNavigation, {}) : !!(data !== null && data !== void 0 && data.contactDetail) && _jsx(Popover, {
        triggerItem: _jsx(NavItem, {
          title: "".concat(data === null || data === void 0 || (_data$contactDetail = data.contactDetail) === null || _data$contactDetail === void 0 ? void 0 : _data$contactDetail.firstName, " ").concat(data === null || data === void 0 || (_data$contactDetail2 = data.contactDetail) === null || _data$contactDetail2 === void 0 ? void 0 : _data$contactDetail2.lastName),
          "date-testid": "Global-UserName-Desktop"
        }),
        children: _jsx(AuthSubNav, {
          labels: labels,
          onLogout: logout
        })
      }), _jsx(AuthContentManagerPIVariant, {
        isLoginModalOpen: isLoginModalOpen,
        toggleLoginModal: toggleLoginModal
      })]
    }))]
  });
  function renderSubNavItems(list, showHeading) {
    return list.map(item => {
      return _jsxs(List, _objectSpread(_objectSpread({}, listStyles), {}, {
        children: [showHeading && item.title && _jsx(Heading, _objectSpread(_objectSpread({}, headingStyles), {}, {
          children: item.title
        })), item.navOptions.map(option => {
          var _option$url;
          return _createElement(ListItem, _objectSpread(_objectSpread({}, listItemStyles), {}, {
            key: option.title,
            "data-testid": "listItem"
          }), _jsx("a", {
            href: (_option$url = option.url) !== null && _option$url !== void 0 ? _option$url : '/',
            children: _jsx(Text, _objectSpread(_objectSpread({}, linkStyles), {}, {
              children: option.title
            }))
          }));
        })]
      }), item.title);
    });
  }
}
var buttonStyles = {
  width: '7.5rem',
  height: '2.75rem',
  borderRadius: '5px',
  _hover: {
    boxShadow: 'none',
    backgroundColor: '#005a6a'
  }
};